import { Component, Input } from "@angular/core";
import { MenuItem } from "primeng/api";
import { ContextMenuService } from "src/app/services/shared/context-menu-service";
import { ButtonOption } from "../datatable/datatablecolumn/datatablecolumn.component";

@Component({
    standalone: false,
    selector: "custom-menu",
    templateUrl: "./custom-menu.component.html",
})
export class CustomMenu {
    @Input() itemIndex: number = 0;
    @Input() options: ButtonOption[] = [];
    @Input() datasetLength: number = 0;
    @Input() item: {} = {};

    private contextMenuService: ContextMenuService;

    constructor(contextMenuService: ContextMenuService) {
        this.contextMenuService = contextMenuService;
    }

    isButtonVisible(row: any, option: ButtonOption): boolean {
        var value = true;

        if (option.hide) value = !option.hide(row, this.datasetLength);

        return value;
    }

    toggleContextMenu(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();

        let copiedEvent = this.copyEvent(event);

        let newEvent = new MouseEvent(event.type, copiedEvent);

        this.contextMenuService.show(
            newEvent,
            this.convertOptions(this.options)
        );

        return false;
    }

    convertOptions(options: ButtonOption[]): MenuItem[] {
        return options.map((option) => {
            return {
                items: option.suboptions?.map((optionSub) => {
                    return {
                        label: optionSub.title || optionSub.value,
                        visible: optionSub.hide
                            ? !optionSub.hide(this.item, this.datasetLength)
                            : true,
                        command: () => {
                            optionSub.click(optionSub.controller, optionSub.id, this.item);
                        },
                    };
                }),
                label: option.title || option.value,
                visible: option.hide
                    ? !option.hide(this.item, this.datasetLength)
                    : true,
                command: () => {
                    option.click(option.controller, option.id, this.item);
                },
            };
        });
    }

    close() {
        this.contextMenuService.close();
    }

    private getParentOffsetLeft(target: any): number {
        let offsetLeft = target ? (target.offsetLeft - (target.scrollLeft || 0)) : 0;

        if (target.offsetParent)
            offsetLeft += this.getParentOffsetLeft(target.offsetParent);

        return offsetLeft;
    }

    private copyEvent(event: MouseEvent) {
        let newX = event.clientX;
        let newY = event.clientY;
        let target = event.currentTarget as HTMLButtonElement;
        let parentLeft = (event.target as any)?.offsetParent?.offsetLeft ?? 0;

        parentLeft = this.getParentOffsetLeft(target.offsetParent);

        if (parentLeft > window.innerWidth) parentLeft = window.innerWidth - 75;

        let targetRightEdge =
            parentLeft + target.offsetLeft + target.clientWidth;

        if (window.innerWidth - 175 < targetRightEdge)
            newX =
                targetRightEdge - 175 - target.clientWidth - target.offsetLeft;
        else newX = targetRightEdge + 5;

        let obj = {
            AT_TARGET: event.AT_TARGET,
            BUBBLING_PHASE: event.BUBBLING_PHASE,
            CAPTURING_PHASE: event.CAPTURING_PHASE,
            NONE: event.NONE,
            altKey: event.altKey,
            bubbles: event.bubbles,
            button: event.button,
            buttons: event.buttons,
            cancelBubble: event.cancelBubble,
            cancelable: event.cancelable,
            clientX: newX,
            clientY: newY,
            composed: event.composed,
            ctrlKey: event.ctrlKey,
            currentTarget: event.currentTarget,
            defaultPrevented: event.defaultPrevented,
            detail: event.detail,
            eventPhase: event.eventPhase,
            isTrusted: event.isTrusted,
            metaKey: event.metaKey,
            movementX: event.movementX,
            movementY: event.movementY,
            offsetX: event.offsetX,
            offsetY: event.offsetY,
            pageX: event.pageX,
            pageY: event.pageY,
            relatedTarget: event.relatedTarget,
            returnValue: event.returnValue,
            screenX: event.screenX,
            screenY: event.screenY,
            shiftKey: event.shiftKey,
            srcElement: event.srcElement,
            target: event.target,
            timeStamp: event.timeStamp,
            type: event.type,
            view: event.view,
            which: event.which,
            x: event.x,
            y: event.y,
        };

        return obj;
    }
}
